<template>
    <div class="reporting">
        <div style="display: flex;">
          <Headbuttom></Headbuttom>
           
          <div @click="handFromshow"><el-input
          size="small"
          class="dev_dowm"
          placeholder=""
          suffix-icon="el-icon-arrow-down"
          :readonly="true"
          >
        </el-input>
        </div>
       
        </div>

        <div class="attheadfrom" v-if="flag">
        <el-form
            :inline="true"
            size="small"
            :model="searchParams"
            class="demo-form-inline"
        >
            <el-form-item label="设备名称">
                <el-select v-model="name" placeholder="请选择">
                    <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="设备序列号">
                <el-input v-model="searchParams.f_serial_number"></el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="onSubmit">{{$t("devtable.cx")}}</el-button>
            </el-form-item>

        </el-form>
        </div>

        <Tables @handlerow="handlerow"
        @handlpages="handlpages"
        @handleSizeChange="handleSizeChange"
        :tableLabel="tableLabel"
        :tableData="tableData"
        :flags="flags"
        :operation="operation"
        :configs="configs"></Tables>

        <parkdolg ref="park" :options="options"></parkdolg>
    </div>
</template>
<script>
import Tables from '@/components/table'
import parkdolg from './commpoents/parkdolg'
export default {
     components:{
        parkdolg,
        Tables,
   
    },
    data(){
        return{
            flag:false,
            searchParams:{
                name:'',
                f_serial_number:''
            },
            options: [],
            tableLabel:[
            
            {
              prop: "name",
              label: '设备名称',
              align: "center",
            },
            {
              prop: "name",
              label: '设备序列号',
              align: "center",
            },
            {
              prop: "number",
              label: '摄像头1管理车位数',
              align: "center",
            },
            {
              prop: "dept_name",
              label: '摄像头2管理车牌数',
              align: "center",
            },
            
            {
              prop: "mobile",
              label: '路由1MAC+SSID',
              align: "center",
            },
            {
              prop: "apply_time",
              label: '路由2MAC+SSID',
              align: "center",
            },
            
            ],
            tableData:[],
            operation:{
              width:150,
              data:[
                {
                  name: "修改",
                  type: "success",
                },
                
                
              ]
            },
            // 分页数据
            configs: {
              page_index:1,
              pagesize: 10,
              total: 20,
              loading: false, // 加载状态
            },
            flags: {
              show: false, // 多选是否显示
              ishow: true, // 序号是否显示
            },
            UserInfo:JSON.parse(window.localStorage.getItem('user')),
        }
    },
    mounted(){
        this.hanequlist()
    },
    methods:{
        // 获取设备
        hanequlist(){
            let data={
                method:'co.device.dropdown.list',
                agent_id:this.UserInfo.agent_id
            }
            this.$serve(data).then(res=>{
                if(res.data.code==0){
                    this.options = res.data.data
                }
            })
        },
        onPlus(){
            this.$refs.park.dialogVisible = true
        },
        handFromshow(){
            this.flag = !this.flag
        },
        onSubmit(){

        },
        handlerow(){

        },
        handlpages(){

        },
        handleSizeChange(){

        }
    }
}
</script>
<style scoped>
.reporting{
    padding: 20px;
    background-color: #fff;
}
.dev_dowm{
    margin-left: 30px;
}
.attheadfrom {
    padding: 20px;
    margin-top: 10px;
  }
</style>